import { render, staticRenderFns } from "./EventLabel.vue?vue&type=template&id=1bdb7788&scoped=true&"
import script from "./EventLabel.vue?vue&type=script&lang=js&"
export * from "./EventLabel.vue?vue&type=script&lang=js&"
import style0 from "./EventLabel.vue?vue&type=style&index=0&id=1bdb7788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdb7788",
  null
  
)

export default component.exports